"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refundSubmittedStatus = exports.refundInitialStatus = exports.refundFullStatus = exports.refundErrorStatus = exports.refundDraftStatus = void 0;
var refundInitialStatus = exports.refundInitialStatus = 'INITIAL';
var refundDraftStatus = exports.refundDraftStatus = 'DRAFT';
var refundSubmittedStatus = exports.refundSubmittedStatus = 'SUBMITTED';
var refundErrorStatus = exports.refundErrorStatus = 'ERROR';
var refundFullStatus = exports.refundFullStatus = 'FULL';
